import React from 'react';
import { useT } from '../i18n';
import PageSEO from './common/PageSEO';

const T = {
  es: {
    title: 'Contrato de Encargado del Tratamiento (DPA)',
    version: 'Versión 1.0',
    seoDescription: 'Contrato de Encargado del Tratamiento (DPA) de la plataforma Cadenia conforme al artículo 28 del RGPD: finalidades, categorías de datos, medidas de seguridad, subencargados y transferencias.',
    langNote: 'Este documento se publica en español y en inglés. En caso de discrepancia entre ambas versiones, prevalecerá la versión en español.',
    introTitle: 'Identificación de las partes y marco',
    introText1: 'El presente Contrato de Encargado del Tratamiento (en adelante, el "DPA") regula las condiciones en las que Blue Visibility Tech S.L.U. (marca Cadenia), con NIF B09726571 y domicilio en Calle Princesa 31, 2º, Madrid (en adelante, "el Encargado"), trata datos personales por cuenta del Cliente (en adelante, "el Responsable") en el marco de la prestación de los servicios de la plataforma Cadenia.',
    introText2: 'Este DPA se celebra en cumplimiento del artículo 28 del Reglamento (UE) 2016/679 (RGPD) y de la Ley Orgánica 3/2018 (LOPDGDD), complementa las condiciones de servicio acordadas entre las partes y forma parte integrante de ellas.',
    s1Title: '1. Objeto y duración',
    s1Text1: 'El objeto de este DPA es el tratamiento de datos personales necesario para prestar los servicios de la plataforma Cadenia. El tratamiento tendrá la misma duración que la relación contractual entre las partes.',
    s1Text2: 'A la finalización del servicio, el Encargado devolverá al Responsable los datos personales en un formato estructurado y de uso común (CSV o JSON) o los suprimirá, según las instrucciones del Responsable, en un plazo máximo de 30 días. Las copias de seguridad se eliminarán conforme a su ciclo de rotación en un máximo de 90 días adicionales. Quedan a salvo los datos que deban conservarse bloqueados en virtud de una obligación legal.',
    s2Title: '2. Naturaleza y finalidad del tratamiento',
    s2Text: 'Los datos personales se tratan exclusivamente para la prestación de los servicios de visibilidad y gestión de la cadena de transporte contratados por el Responsable, que comprenden:',
    s2Items: [
      'Seguimiento de envíos y rutas: registro de hitos y estados de recogida, tránsito y entrega.',
      'Geolocalización de vehículos: recepción y visualización de posiciones GPS asociadas a matrículas durante la prestación del servicio de transporte.',
      'Reserva de franjas horarias (slots): planificación de operaciones de carga y descarga en las instalaciones del Responsable.',
      'Gestión documental de transporte: almacenamiento y consulta de documentación asociada a los envíos.',
      'Notificaciones y alertas operativas por correo electrónico o dentro de la plataforma.',
      'Analítica e informes (Intelligence): elaboración de cuadros de mando e indicadores de servicio.',
    ],
    s3Title: '3. Categorías de interesados',
    s3Items: [
      'Empleados y usuarios autorizados del Responsable.',
      'Empleados y usuarios de las empresas transportistas que prestan servicio al Responsable.',
      'Conductores que ejecutan los transportes.',
      'Personas de contacto de remitentes y destinatarios en los puntos de recogida y entrega.',
    ],
    s4Title: '4. Categorías de datos personales',
    s4Items: [
      { label: 'Datos identificativos y de contacto de usuarios:', text: 'nombre, correo electrónico, teléfono, empresa, idioma y zona horaria.' },
      { label: 'Datos de conductores:', text: 'nombre, teléfono de contacto y matrícula del vehículo asignado.' },
      { label: 'Datos de geolocalización:', text: 'posiciones GPS de vehículos vinculadas a matrícula durante la ejecución del transporte.' },
      { label: 'Datos de contacto en puntos de entrega:', text: 'nombre y teléfono de las personas de contacto comunicadas para coordinar recogidas y entregas.' },
      { label: 'Datos de uso y registro:', text: 'registros de acceso y actividad en la plataforma (identificador de usuario, dirección IP, fecha y acción realizada).' },
    ],
    s4Note: 'La plataforma no está diseñada para tratar categorías especiales de datos (art. 9 RGPD). El Responsable se compromete a no incluir este tipo de datos en campos de texto libre, observaciones o documentos cargados en la plataforma.',
    s5Title: '5. Obligaciones del Encargado',
    s5Text: 'El Encargado se compromete a:',
    s5Items: [
      'Tratar los datos personales únicamente siguiendo instrucciones documentadas del Responsable, incluso respecto de las transferencias internacionales, e informarle de inmediato si considera que una instrucción infringe el RGPD u otra normativa aplicable.',
      'Garantizar que las personas autorizadas para tratar datos personales se han comprometido a la confidencialidad o están sujetas a una obligación legal de confidencialidad.',
      'Aplicar las medidas técnicas y organizativas del artículo 32 del RGPD descritas en la sección 6.',
      'Respetar el régimen de subencargados descrito en la sección 7.',
      'Asistir al Responsable, teniendo en cuenta la naturaleza del tratamiento, en la atención de las solicitudes de ejercicio de derechos de los interesados (acceso, rectificación, supresión, oposición, limitación y portabilidad), trasladándole sin dilación cualquier solicitud recibida directamente.',
      'Asistir al Responsable en el cumplimiento de los artículos 32 a 36 del RGPD: seguridad, notificación de violaciones, evaluaciones de impacto y consultas previas a la autoridad de control.',
      'Notificar al Responsable las violaciones de seguridad de los datos personales sin dilación indebida y, a más tardar, en un plazo de 48 horas desde que tenga constancia de ellas, con la información disponible sobre su naturaleza, los interesados y datos afectados, las consecuencias probables y las medidas adoptadas o propuestas.',
      'Mantener el registro de actividades de tratamiento previsto en el artículo 30.2 del RGPD.',
      'Suprimir o devolver los datos al término del servicio conforme a la sección 1.',
      'Poner a disposición del Responsable toda la información necesaria para demostrar el cumplimiento de este DPA y permitir las auditorías previstas en la sección 9.',
    ],
    s6Title: '6. Medidas de seguridad',
    s6Text: 'El Encargado aplica, entre otras, las siguientes medidas técnicas y organizativas:',
    s6Items: [
      { label: 'Cifrado:', text: 'de las comunicaciones en tránsito (TLS 1.2 o superior) y de los datos en reposo.' },
      { label: 'Control de acceso:', text: 'autenticación gestionada, control de acceso basado en roles y principio de mínimo privilegio.' },
      { label: 'Aislamiento entre clientes:', text: 'segregación estricta de los datos por cuenta; cada transportista únicamente accede a los envíos que tiene asignados.' },
      { label: 'Infraestructura en la UE:', text: 'servicios desplegados en centros de datos de AWS en la Unión Europea.' },
      { label: 'Monitorización y auditoría:', text: 'registro de actividad de la infraestructura, detección de amenazas y cortafuegos de aplicaciones web.' },
      { label: 'Continuidad:', text: 'copias de seguridad automáticas con capacidad de recuperación a un punto en el tiempo.' },
      { label: 'Gestión de plataforma:', text: 'arquitectura serverless gestionada con actualización continua de los componentes por el proveedor de infraestructura.' },
    ],
    s7Title: '7. Subencargados',
    s7Text1: 'El Responsable autoriza de forma general la contratación de los subencargados necesarios para prestar el servicio. La lista vigente es la siguiente:',
    s7TableHead: ['Subencargado', 'Servicio', 'Ubicación del tratamiento', 'Garantías'],
    s7Rows: [
      ['BlueCMR S.L.U. (España — sociedad participada al 100% por Blue Visibility Tech S.L.U.)', 'Gestión de documentos de transporte digitales y firma electrónica (módulo Documents)', 'Unión Europea', 'Contrato intragrupo conforme al art. 28 RGPD; aplica su propio DPA y lista de subencargados'],
      ['Amazon Web Services EMEA SARL (Luxemburgo)', 'Infraestructura cloud: computación, almacenamiento, autenticación, entrega de contenidos y envío de correos y notificaciones', 'Región UE (París, eu-west-3)', 'DPA de AWS con Cláusulas Contractuales Tipo'],
      ['MongoDB Limited (Irlanda)', 'Base de datos gestionada (MongoDB Atlas), desplegada sobre infraestructura de AWS', 'Unión Europea', 'DPA de MongoDB con Cláusulas Contractuales Tipo'],
      ['Zoho Corporation B.V. (Países Bajos)', 'Analítica e informes (módulo Intelligence)', 'Centros de datos de Zoho en la UE', 'DPA de Zoho con Cláusulas Contractuales Tipo'],
    ],
    s7TextGroup: 'La gestión de documentos de transporte se presta a través de BlueCMR, plataforma operada por BlueCMR S.L.U., sociedad íntegramente participada por Blue Visibility Tech S.L.U. Los datos comunicados a BlueCMR con esta finalidad quedan sujetos a su propio Contrato de Encargado del Tratamiento y a su propia lista de subencargados, publicados en bluecmr.com/dpa, que se incorporan a este DPA por referencia.',
    s7Text2: 'El Encargado informará al Responsable con al menos 30 días de antelación de cualquier adición o sustitución de subencargados, de modo que el Responsable pueda oponerse de forma motivada. Todo subencargado queda sujeto por contrato a obligaciones de protección de datos equivalentes a las de este DPA, y el Encargado responde ante el Responsable del cumplimiento por parte de sus subencargados.',
    s8Title: '8. Transferencias internacionales',
    s8Text: 'Los datos personales se alojan y tratan por defecto en la Unión Europea. No se realizan transferencias a terceros países salvo las que, en su caso, efectúen los subencargados listados, y siempre con las garantías del Capítulo V del RGPD (decisiones de adecuación, incluido el Marco de Privacidad de Datos UE-EE. UU., o Cláusulas Contractuales Tipo).',
    s9Title: '9. Derechos del Responsable y auditoría',
    s9Items: [
      'Impartir instrucciones documentadas sobre el tratamiento en cualquier momento.',
      'Auditar el cumplimiento de este DPA, directamente o mediante un tercero independiente, con un preaviso razonable de 15 días y un máximo de una auditoría anual, salvo violación de seguridad o requerimiento de una autoridad de control. El Encargado podrá atender la auditoría, en primer término, mediante documentación, informes y certificaciones de sus proveedores de infraestructura.',
      'Elegir entre la devolución o la supresión de los datos a la finalización del servicio.',
    ],
    s10Title: '10. Trazabilidad de las operaciones',
    s10Text: 'La plataforma mantiene un registro de eventos que documenta el origen de cada actualización de estado de un envío (sistema de origen, fecha y autor), lo que garantiza la trazabilidad e integridad de la información de transporte y permite atender solicitudes de información del Responsable o de las autoridades competentes.',
    s11Title: '11. Responsabilidad',
    s11Text: 'Cada parte responderá de los daños causados por los tratamientos que infrinjan el RGPD conforme a su artículo 82. El Responsable garantiza que dispone de base jurídica suficiente para los datos personales que introduce en la plataforma o que instruye tratar, y que ha informado a los interesados conforme a los artículos 13 y 14 del RGPD.',
    s12Title: '12. Ley aplicable y jurisdicción',
    s12Text: 'Este DPA se rige por la legislación española. Para cualquier controversia derivada del mismo, las partes se someten a los juzgados y tribunales de Madrid, salvo que resulte aplicable un fuero imperativo distinto.',
    contactTitle: '13. Contacto',
    contactText: 'Para cualquier cuestión relativa a este DPA o al tratamiento de datos personales:',
    contactEmailLabel: 'Email:',
    contactDpoLabel: 'Delegado de Protección de Datos:',
    contactDpo: 'Jesús Santín',
    contactAddressLabel: 'Dirección:',
    contactAddress: 'Blue Visibility Tech S.L.U., Calle Princesa 31, 2º, Madrid',
    historyTitle: 'Historial de versiones',
    historyRows: [['v1.0', 'Versión inicial']],
  },
  en: {
    title: 'Data Processing Agreement (DPA)',
    version: 'Version 1.0',
    seoDescription: 'Data Processing Agreement (DPA) for the Cadenia platform under Article 28 GDPR: purposes, data categories, security measures, subprocessors and international transfers.',
    langNote: 'This document is published in Spanish and English. In case of any discrepancy between the two versions, the Spanish version shall prevail.',
    introTitle: 'Identification of the parties and framework',
    introText1: 'This Data Processing Agreement (the "DPA") governs the conditions under which Blue Visibility Tech S.L.U. (Cadenia brand), Tax ID (NIF) B09726571, with registered address at Calle Princesa 31, 2º, Madrid, Spain (the "Processor"), processes personal data on behalf of the Client (the "Controller") in the context of providing the services of the Cadenia platform.',
    introText2: 'This DPA is entered into pursuant to Article 28 of Regulation (EU) 2016/679 (GDPR) and Spanish Organic Law 3/2018 (LOPDGDD). It supplements the terms of service agreed between the parties and forms an integral part of them.',
    s1Title: '1. Subject matter and duration',
    s1Text1: 'The subject matter of this DPA is the processing of personal data necessary to provide the services of the Cadenia platform. Processing shall last for the duration of the contractual relationship between the parties.',
    s1Text2: 'Upon termination of the service, the Processor shall return the personal data to the Controller in a structured, commonly used format (CSV or JSON) or delete it, as instructed by the Controller, within a maximum of 30 days. Backups are deleted according to their rotation cycle within a further 90 days at most. Data that must be kept blocked under a legal retention obligation is excepted.',
    s2Title: '2. Nature and purpose of the processing',
    s2Text: 'Personal data is processed solely to provide the transport-chain visibility and management services contracted by the Controller, which comprise:',
    s2Items: [
      'Shipment and route tracking: recording of pickup, transit and delivery milestones and statuses.',
      'Vehicle geolocation: receipt and display of GPS positions linked to licence plates while the transport service is being performed.',
      'Time-slot booking (slots): planning of loading and unloading operations at the Controller’s facilities.',
      'Transport document management: storage and consultation of documentation associated with shipments.',
      'Operational notifications and alerts by email or within the platform.',
      'Analytics and reporting (Intelligence): dashboards and service KPIs.',
    ],
    s3Title: '3. Categories of data subjects',
    s3Items: [
      'Employees and authorised users of the Controller.',
      'Employees and users of the carrier companies serving the Controller.',
      'Drivers performing the transports.',
      'Contact persons of senders and recipients at pickup and delivery points.',
    ],
    s4Title: '4. Categories of personal data',
    s4Items: [
      { label: 'User identification and contact data:', text: 'name, email address, phone number, company, language and time zone.' },
      { label: 'Driver data:', text: 'name, contact phone number and licence plate of the assigned vehicle.' },
      { label: 'Geolocation data:', text: 'vehicle GPS positions linked to a licence plate during the performance of the transport.' },
      { label: 'Delivery-point contact data:', text: 'name and phone number of the contact persons provided to coordinate pickups and deliveries.' },
      { label: 'Usage and log data:', text: 'platform access and activity records (user identifier, IP address, date and action performed).' },
    ],
    s4Note: 'The platform is not designed to process special categories of data (Art. 9 GDPR). The Controller undertakes not to include such data in free-text fields, remarks or documents uploaded to the platform.',
    s5Title: '5. Obligations of the Processor',
    s5Text: 'The Processor undertakes to:',
    s5Items: [
      'Process personal data only on documented instructions from the Controller, including with regard to international transfers, and immediately inform the Controller if, in its opinion, an instruction infringes the GDPR or other applicable law.',
      'Ensure that persons authorised to process personal data have committed themselves to confidentiality or are under an appropriate statutory obligation of confidentiality.',
      'Implement the technical and organisational measures of Article 32 GDPR described in Section 6.',
      'Comply with the subprocessor regime described in Section 7.',
      'Assist the Controller, taking into account the nature of the processing, in responding to requests to exercise data subject rights (access, rectification, erasure, objection, restriction and portability), forwarding without delay any request received directly.',
      'Assist the Controller in ensuring compliance with Articles 32 to 36 GDPR: security, breach notification, data protection impact assessments and prior consultation of the supervisory authority.',
      'Notify the Controller of personal data breaches without undue delay and in any event within 48 hours of becoming aware of them, providing the available information on their nature, the data subjects and data affected, the likely consequences and the measures taken or proposed.',
      'Maintain the record of processing activities provided for in Article 30(2) GDPR.',
      'Delete or return the data at the end of the service in accordance with Section 1.',
      'Make available to the Controller all information necessary to demonstrate compliance with this DPA and allow for the audits provided for in Section 9.',
    ],
    s6Title: '6. Security measures',
    s6Text: 'The Processor implements, among others, the following technical and organisational measures:',
    s6Items: [
      { label: 'Encryption:', text: 'of communications in transit (TLS 1.2 or higher) and of data at rest.' },
      { label: 'Access control:', text: 'managed authentication, role-based access control and the principle of least privilege.' },
      { label: 'Tenant isolation:', text: 'strict segregation of data per account; each carrier only accesses the shipments assigned to it.' },
      { label: 'EU infrastructure:', text: 'services deployed in AWS data centres within the European Union.' },
      { label: 'Monitoring and audit:', text: 'infrastructure activity logging, threat detection and a web application firewall.' },
      { label: 'Continuity:', text: 'automatic backups with point-in-time recovery.' },
      { label: 'Platform management:', text: 'managed serverless architecture with components continuously updated by the infrastructure provider.' },
    ],
    s7Title: '7. Subprocessors',
    s7Text1: 'The Controller gives its general authorisation for the engagement of the subprocessors necessary to provide the service. The current list is as follows:',
    s7TableHead: ['Subprocessor', 'Service', 'Processing location', 'Safeguards'],
    s7Rows: [
      ['BlueCMR S.L.U. (Spain — wholly owned subsidiary of Blue Visibility Tech S.L.U.)', 'Digital transport document management and electronic signature (Documents module)', 'European Union', 'Intra-group agreement under Art. 28 GDPR; applies its own DPA and subprocessor list'],
      ['Amazon Web Services EMEA SARL (Luxembourg)', 'Cloud infrastructure: compute, storage, authentication, content delivery and sending of emails and notifications', 'EU region (Paris, eu-west-3)', 'AWS DPA with Standard Contractual Clauses'],
      ['MongoDB Limited (Ireland)', 'Managed database (MongoDB Atlas), deployed on AWS infrastructure', 'European Union', 'MongoDB DPA with Standard Contractual Clauses'],
      ['Zoho Corporation B.V. (Netherlands)', 'Analytics and reporting (Intelligence module)', 'Zoho EU data centres', 'Zoho DPA with Standard Contractual Clauses'],
    ],
    s7TextGroup: 'Transport document management is provided through BlueCMR, a platform operated by BlueCMR S.L.U., a wholly owned subsidiary of Blue Visibility Tech S.L.U. Data communicated to BlueCMR for this purpose is subject to its own Data Processing Agreement and its own subprocessor list, published at bluecmr.com/dpa, which are incorporated into this DPA by reference.',
    s7Text2: 'The Processor shall inform the Controller at least 30 days in advance of any addition or replacement of subprocessors, so that the Controller may object on reasonable grounds. Every subprocessor is bound by contract to data protection obligations equivalent to those of this DPA, and the Processor remains liable to the Controller for the performance of its subprocessors.',
    s8Title: '8. International transfers',
    s8Text: 'Personal data is hosted and processed in the European Union by default. No transfers to third countries take place other than those, if any, carried out by the listed subprocessors, and always subject to the safeguards of Chapter V GDPR (adequacy decisions, including the EU-U.S. Data Privacy Framework, or Standard Contractual Clauses).',
    s9Title: '9. Controller rights and audits',
    s9Items: [
      'Issue documented processing instructions at any time.',
      'Audit compliance with this DPA, directly or through an independent third party, with reasonable prior notice of 15 days and a maximum of one audit per year, except in the event of a security breach or a request from a supervisory authority. The Processor may first satisfy the audit by providing documentation, reports and certifications from its infrastructure providers.',
      'Choose between return or deletion of the data upon termination of the service.',
    ],
    s10Title: '10. Traceability of operations',
    s10Text: 'The platform keeps an event log documenting the origin of every shipment status update (source system, date and author), which guarantees the traceability and integrity of the transport information and makes it possible to respond to information requests from the Controller or the competent authorities.',
    s11Title: '11. Liability',
    s11Text: 'Each party shall be liable for damage caused by processing that infringes the GDPR in accordance with Article 82 thereof. The Controller warrants that it has a sufficient legal basis for the personal data it enters into the platform or instructs to be processed, and that it has informed the data subjects in accordance with Articles 13 and 14 GDPR.',
    s12Title: '12. Governing law and jurisdiction',
    s12Text: 'This DPA is governed by Spanish law. Any dispute arising from it shall be submitted to the courts of Madrid, unless a different mandatory forum applies.',
    contactTitle: '13. Contact',
    contactText: 'For any question regarding this DPA or the processing of personal data:',
    contactEmailLabel: 'Email:',
    contactDpoLabel: 'Data Protection Officer:',
    contactDpo: 'Jesús Santín',
    contactAddressLabel: 'Address:',
    contactAddress: 'Blue Visibility Tech S.L.U., Calle Princesa 31, 2º, Madrid, Spain',
    historyTitle: 'Version history',
    historyRows: [['v1.0', 'Initial version']],
  },
};

const Dpa = () => {
  const t = useT(T);
  return (
    <div className="pt-20">
      <PageSEO title={t.title} description={t.seoDescription} />

      {/* Hero */}
      <section className="bg-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-light text-gray-900 mb-4">{t.title}</h1>
          <p className="text-lg text-gray-600 mb-4">{t.version}</p>
          <p className="text-sm text-gray-500">{t.langNote}</p>
        </div>
      </section>

      {/* Content */}
      <section className="bg-gray-50 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white p-8 sm:p-12 border border-gray-200">

            {/* Intro */}
            <div className="mb-12">
              <h2 className="text-2xl font-light text-gray-900 mb-6">{t.introTitle}</h2>
              <p className="text-gray-600 leading-relaxed mb-4">{t.introText1}</p>
              <p className="text-gray-600 leading-relaxed">{t.introText2}</p>
            </div>

            {/* 1. Objeto y duración */}
            <div className="mb-12">
              <h3 className="text-xl font-medium text-gray-900 mb-4">{t.s1Title}</h3>
              <p className="text-gray-600 leading-relaxed mb-4">{t.s1Text1}</p>
              <p className="text-gray-600 leading-relaxed">{t.s1Text2}</p>
            </div>

            {/* 2. Naturaleza y finalidad */}
            <div className="mb-12">
              <h3 className="text-xl font-medium text-gray-900 mb-4">{t.s2Title}</h3>
              <p className="text-gray-600 leading-relaxed mb-4">{t.s2Text}</p>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                {t.s2Items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>

            {/* 3. Interesados */}
            <div className="mb-12">
              <h3 className="text-xl font-medium text-gray-900 mb-4">{t.s3Title}</h3>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                {t.s3Items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>

            {/* 4. Datos */}
            <div className="mb-12">
              <h3 className="text-xl font-medium text-gray-900 mb-4">{t.s4Title}</h3>
              <ul className="list-disc list-inside text-gray-600 mb-6 space-y-2">
                {t.s4Items.map((item, i) => (
                  <li key={i}><strong>{item.label}</strong> {item.text}</li>
                ))}
              </ul>
              <div className="bg-blue-50 p-4 border border-blue-200">
                <p className="text-blue-800 text-sm">{t.s4Note}</p>
              </div>
            </div>

            {/* 5. Obligaciones */}
            <div className="mb-12">
              <h3 className="text-xl font-medium text-gray-900 mb-4">{t.s5Title}</h3>
              <p className="text-gray-600 leading-relaxed mb-4">{t.s5Text}</p>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                {t.s5Items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>

            {/* 6. Seguridad */}
            <div className="mb-12">
              <h3 className="text-xl font-medium text-gray-900 mb-4">{t.s6Title}</h3>
              <p className="text-gray-600 leading-relaxed mb-4">{t.s6Text}</p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {t.s6Items.map((item, i) => (
                  <div key={i} className="bg-gray-50 p-4 border border-gray-200">
                    <p className="text-sm text-gray-700">
                      <strong className="text-gray-900">{item.label}</strong> {item.text}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            {/* 7. Subencargados */}
            <div className="mb-12">
              <h3 className="text-xl font-medium text-gray-900 mb-4">{t.s7Title}</h3>
              <p className="text-gray-600 leading-relaxed mb-4">{t.s7Text1}</p>
              <div className="overflow-x-auto mb-4">
                <table className="w-full text-sm border border-gray-200">
                  <thead>
                    <tr className="bg-gray-50">
                      {t.s7TableHead.map((head, i) => (
                        <th key={i} className="text-left font-medium text-gray-900 p-3 border-b border-gray-200">{head}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {t.s7Rows.map((row, i) => (
                      <tr key={i} className="border-b border-gray-100 last:border-b-0">
                        {row.map((cell, j) => (
                          <td key={j} className="p-3 text-gray-600 align-top">{cell}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <p className="text-gray-600 leading-relaxed mb-4">{t.s7TextGroup}</p>
              <p className="text-gray-600 leading-relaxed">{t.s7Text2}</p>
            </div>

            {/* 8. Transferencias */}
            <div className="mb-12">
              <h3 className="text-xl font-medium text-gray-900 mb-4">{t.s8Title}</h3>
              <p className="text-gray-600 leading-relaxed">{t.s8Text}</p>
            </div>

            {/* 9. Derechos del Responsable */}
            <div className="mb-12">
              <h3 className="text-xl font-medium text-gray-900 mb-4">{t.s9Title}</h3>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                {t.s9Items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ul>
            </div>

            {/* 10. Trazabilidad */}
            <div className="mb-12">
              <h3 className="text-xl font-medium text-gray-900 mb-4">{t.s10Title}</h3>
              <p className="text-gray-600 leading-relaxed">{t.s10Text}</p>
            </div>

            {/* 11. Responsabilidad */}
            <div className="mb-12">
              <h3 className="text-xl font-medium text-gray-900 mb-4">{t.s11Title}</h3>
              <p className="text-gray-600 leading-relaxed">{t.s11Text}</p>
            </div>

            {/* 12. Ley aplicable */}
            <div className="mb-12">
              <h3 className="text-xl font-medium text-gray-900 mb-4">{t.s12Title}</h3>
              <p className="text-gray-600 leading-relaxed">{t.s12Text}</p>
            </div>

            {/* 13. Contacto */}
            <div className="mb-12">
              <h3 className="text-xl font-medium text-gray-900 mb-4">{t.contactTitle}</h3>
              <p className="text-gray-600 leading-relaxed mb-4">{t.contactText}</p>
              <div className="bg-gray-50 p-6 border border-gray-200">
                <p className="text-gray-700 mb-2">
                  <strong>{t.contactEmailLabel}</strong>{' '}
                  <a href="mailto:contact@cadenia.eu" className="text-primary-600 hover:underline">contact@cadenia.eu</a>
                </p>
                <p className="text-gray-700 mb-2">
                  <strong>{t.contactDpoLabel}</strong> {t.contactDpo}
                </p>
                <p className="text-gray-700">
                  <strong>{t.contactAddressLabel}</strong> {t.contactAddress}
                </p>
              </div>
            </div>

            {/* Historial de versiones */}
            <div className="border-t border-gray-200 pt-8">
              <h4 className="text-sm font-medium text-gray-900 mb-3">{t.historyTitle}</h4>
              <ul className="text-sm text-gray-500 space-y-1">
                {t.historyRows.map((row, i) => (
                  <li key={i}>{row[0]} — {row[1]}</li>
                ))}
              </ul>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Dpa;
